/* @flow */

import { createSelector } from 'reselect';
import _ from 'lodash';

// import { getUndoableState } from './undoable';
import { StepState, Steps } from '../utils/constants';
import { StepOrder, getStepDataByKey } from '../utils/stepHelpers';

import type { StateType } from '../actions/progress';

const getState = (state: AppStateType) => state.progress;
const getDesignState = (state: AppStateType) => state.design;

export const getDesignLoading = createSelector(
  [getDesignState],
  state => state.loading,
);

type ProgressStatusType = {
  [key: string]: string,
};

export const getStatus = createSelector(
  [getState],
  (state): ProgressStatusType => state.status,
);

export const getStepList = createSelector(
  [() => StepOrder],
  s => s,
);

// export const getStatus = createSelector(
//   [getState],
//   (state): ProgressStatusType => state.status,
// );

// export const getStepDataByKey = createSelector(
//   getStatus,
//   stepStats => _.memoize(
//     (key) => getStepDataByKeyByKey(key),
//   ),
// );

export const getStepGroupData = createSelector(
  [getStatus],
  stepStatus => _.map(
    stepStatus,
    (status: string, key: string) => ({
      status,
      // ..._.omit(getStepDataByKey(key), ['steps']),
      ...getStepDataByKey(key),
    }),
  ),
);

export const getActive = createSelector(
  [getState],
  (state: StateType): string => state.active,
);

export const getErrors = createSelector(
  [getStatus],
  // stepList => _.pickBy(stepList, status => status === StepState.ERROR, {}),
  stepList => _.pickBy(stepList, status => status === StepState.ERROR),
);

export const getCompleteCount = createSelector(
  [getStatus],
  (status): number => _.filter(status, s => s === StepState.COMPLETE).length,
);

export const getNextEnabled = createSelector(
  [getActive, getErrors],
  (active, status) => active
    !== _.last(StepOrder) && status[active] !== StepState.ERROR);

export const getBackEnabled = createSelector(
  [getActive],
  (active: string) => active !== _.first(StepOrder),
);

export const getAutocompleteEnabled = createSelector(
  [getActive, getErrors, getDesignLoading],
  (active: string, errors: ProgressStatusType, loading: boolean) => {
    if (loading) return false;
    const index = StepOrder.findIndex(i => i === active);
    return _.isEmpty(errors) && index < StepOrder.findIndex(i => i === Steps.STEP_ANALYSIS);
  },
);

export const getResetEnabled = createSelector(
  [getActive, getDesignLoading],
  (active: string, loading: boolean) => {
    if (loading) return false;
    const index = StepOrder.findIndex(i => i === active);
    return index < StepOrder.findIndex(i => i === Steps.STEP_ANALYSIS); // Steps.LOSS_REVIEW
  },
);

export default {
  getStatus,
  getActive,
  getErrors,
  getCompleteCount,
  getNextEnabled,
  getBackEnabled,
  getAutocompleteEnabled,
  getResetEnabled,
};



// WEBPACK FOOTER //
// ./src/selectors/progress.js